import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";

import { useDispatch } from "react-redux";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";

import { projectPriority } from "../lib/utils";
import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";
import { entries } from "lodash";
const AddProjectStepOne = ({ workers, ...props }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [dictionaries, setDictionaries] = useState({});

  const { values, form } = props;

  const DICTIONARIES_TO_LOAD = [
    { name: "projectType", path: "/dictionary/projectProjectType/fieldName" },
  ];

  const fetchDictionary = async (dictionaryName, path) => {
    const response = await GlobalAuthFetch({ path });
    const entries = response?.payload?.data?.dictionaryEntries || [];

    setDictionaries((prev) => ({
      ...prev,
      [dictionaryName]: entries,
    }));
  };

  useEffect(() => {
    // LOADING DICTIONARIS
    const loadDictionaries = async () => {
      await Promise.all(
        DICTIONARIES_TO_LOAD.map((dict) =>
          fetchDictionary(dict.name, dict.path)
        )
      );
    };

    loadDictionaries();
  }, []);

  return (
    <div className="AddProjectStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:crm.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:project.projectName")}`}
            name="projectName"
            data-cy="projectName"
          />
        </Col>

        <Col xs={12}>
          <Field
            component={BMXTextField}
            label={`${t("global:project.projectDescription")}`}
            name="projectDescription"
            data-cy="projectDescription"
            multiline={true}
            maxRows={4}
          />
        </Col>

        <Col xs={{ span: 5 }}>
          <Field
            component={BMXSelectField}
            values={workers?.map((el) => ({
              name: `${el.firstName} ${el.lastName}`,
              value: el.uuid,
            }))}
            label={t("global:project.projectClient")}
            name="projectClient"
            data-cy="projectClient"
          />
        </Col>
        <Col xs={{ span: 5, offset: 2 }}>
          <Field
            component={BMXSelectField}
            values={workers?.map((el) => ({
              name: `${el.firstName} ${el.lastName}`,
              value: el.uuid,
            }))}
            label={t("global:project.projectManager")}
            name="projectManager"
            data-cy="projectManager"
          />
        </Col>

        <Col xs={4}>
          <Field
            component={BMXSelectField}
            values={projectPriority}
            label={t("global:project.projectPriority")}
            name="projectPriority"
            data-cy="projectPriority"
          />
        </Col>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXSelectField}
            values={dictionaries["projectType"]?.map((el) => ({
              name: el.entryName,
              value: el.uuid,
            }))}
            label={`${t("global:project.projectType")}`}
            name="projectType"
            data-cy="projectType"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={{ span: 4 }}>
          <Field
            component={BMXDatePicker}
            label={`${t("global:project.projectDeadline")}*`}
            name="projectDeadline"
            data-cy="projectDeadline"
          />
        </Col>
      </Row>
    </div>
  );
};

export default AddProjectStepOne;
